var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDomain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.60596,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E0F2FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 19.606H23.8C22.1198 19.606 21.2798 19.606 20.638 19.9329C20.0735 20.2206 19.6146 20.6795 19.327 21.244C19 21.8857 19 22.7258 19 24.406V32.806C19 34.4861 19 35.3262 19.327 35.9679C19.6146 36.5324 20.0735 36.9914 20.638 37.279C21.2798 37.606 22.1198 37.606 23.8 37.606H32.2C33.8802 37.606 34.7202 37.606 35.362 37.279C35.9265 36.9914 36.3854 36.5324 36.673 35.9679C37 35.3262 37 34.4861 37 32.806V29.606M28 24.606H32V28.606M31.5 20.106V18.606M35.4393 21.1666L36.5 20.106M36.5103 25.106H38.0103M19 29.9531C19.6519 30.0537 20.3199 30.106 21 30.106C25.3864 30.106 29.2653 27.9335 31.6197 24.606",
    stroke: "#0086C9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.60596,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F0F9FF",
    strokeWidth: 8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomain);
export default __webpack_public_path__ + "static/media/Domain.3c0b8ad6d8a68d95c636027598a412cd.svg";
export { ForwardRef as ReactComponent };